import find from 'lodash/find';
import { createSelector } from 'reselect';

import { timeSlotChatTextSelector } from '../../store/timeSlotChat/selectors';
import { onlineChatIntervalsSelector } from '../../store/examData/selectors';
import { completeSTEP3Selector } from '../../store/step/selectors';

const chatIntervalSelector = createSelector(
  onlineChatIntervalsSelector,
  timeSlotChatTextSelector,
  completeSTEP3Selector,
  (chatIntervals, timeSlotText, stepCompleteSTEP3) => {
    const currentValue = find(chatIntervals, { text: timeSlotText });
    return {
      chatIntervalsText: chatIntervals.map(item => item.text),
      currentValue: currentValue ? currentValue.text : '',
      stepCompleteSTEP3,
    };
  },
);

export default chatIntervalSelector;
